import MapMarkerIcon from "./base/MapMarkerIcon";
//-----------------------------------------------
export var DefaultBlue = new MapMarkerIcon("https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png", [25, 41]);
export var DefaultGold = new MapMarkerIcon("https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-gold.png", [25, 41]);
export var DefaultRed = new MapMarkerIcon("https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png", [25, 41]);
export var DefaultGreen = new MapMarkerIcon("https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png", [25, 41]);
//-----------------------------------------------
// url fix is in MapMarkerIcon.ts
var BasePath = "%basePath%/img/";
var DefaultMarkerSize = [100.0 / 4.0, 125.0 / 4.0];
var DefaultAnchorOffset = [
    DefaultMarkerSize[0] / 2.0,
    -DefaultMarkerSize[1] / 2.0,
];
export var None = new MapMarkerIcon("".concat(BasePath, "icon_none.svg"), [25, 25], [0, 25 / 2]);
export var Ausflugsziel = new MapMarkerIcon("".concat(BasePath, "icon_ausflugsziel.svg"), DefaultMarkerSize, undefined, DefaultAnchorOffset);
export var Automat = new MapMarkerIcon("".concat(BasePath, "icon_automaten.svg"), [28.084, 25.019]);
export var Bahnhof = new MapMarkerIcon("".concat(BasePath, "icon_bahnhof.svg"), DefaultMarkerSize, undefined, DefaultAnchorOffset);
export var Haltestelle = new MapMarkerIcon("".concat(BasePath, "icon_haltestellen.svg"), DefaultMarkerSize, undefined, DefaultAnchorOffset);
export var Hotel = new MapMarkerIcon("".concat(BasePath, "icon_hotel.svg"), DefaultMarkerSize, undefined, DefaultAnchorOffset);
export var ParkAndRide = new MapMarkerIcon("".concat(BasePath, "icon_parkandride.svg"), DefaultMarkerSize, undefined, DefaultAnchorOffset);
export var Taxi = new MapMarkerIcon("".concat(BasePath, "icon_taxi.svg"), [33.537, 28.112]);
export var Verkaufsstelle = new MapMarkerIcon("".concat(BasePath, "icon_verkaufsstellen.svg"), DefaultMarkerSize, undefined, DefaultAnchorOffset);
export var Uncategorized = new MapMarkerIcon("".concat(BasePath, "icon_fallback.svg"), DefaultMarkerSize, undefined, DefaultAnchorOffset);
//-----------------------------------------------
export function getIconForCategory(location) {
    switch (location.getPrimaryCategorySlug()) {
        case "ausflugsziel":
            return Ausflugsziel;
        case "automat":
            return Automat;
        case "bahnhof":
        case "haltestelle":
            return Bahnhof;
        case "hotel":
            return Hotel;
        case "park-ride":
            return ParkAndRide;
        case "taxi":
            return Taxi;
        case "verkaufsstelle":
            return Verkaufsstelle;
        default:
            return Uncategorized;
    }
}
